import { useRouter } from "next/router";
import { useCallback } from "react";

export const useQueryParams = () => {
  const router = useRouter();
  const query = router.query as Record<string, string>;

  // Change single query param
  const changeQueryParam = useCallback(
    (key: string, value: any) => {
      const newQuery = { ...query };

      if (
        value === "" ||
        value === undefined ||
        value === null ||
        (Array.isArray(value) && value.length === 0)
      ) {
        delete newQuery[key];
      } else {
        newQuery[key] = value;
      }

      router.push({ pathname: router.pathname, query: newQuery }, undefined, {
        shallow: true,
      });
    },
    [query, router]
  );

  // Apply multiple query params at once
  const apply = useCallback(
    (params: Record<string, any>) => {
      const newQuery = { ...query };

      Object.entries(params).forEach(([key, value]) => {
        if (
          value === "" ||
          value === null ||
          value === undefined ||
          (Array.isArray(value) && value.length === 0)
        ) {
          delete newQuery[key];
        } else {
          newQuery[key] = value;
        }
      });

      router.push({ pathname: router.pathname, query: newQuery }, undefined, {
        shallow: true,
      });
    },
    [query, router]
  );

  // Clear all query parameters
  const clear = useCallback(() => {
    router.push({ pathname: router.pathname, query: {} }, undefined, {
      shallow: true,
    });
  }, [router]);

  return { query, changeQueryParam, apply, clear };
};
